export default __webpack_public_path__ + "static/media/6.2880d806.png";